import { useEffect, useState } from 'react'
import { Ruler, Weight } from 'lucide-react'
import Modal from '../../../components/ERP/Modal/Modal'
import { patientService } from '../../../services/patientApi'
import './PatientsPage.css'

const KINDS = {
  peso: {
    title: 'Registro de peso',
    subtitle: 'Última pesagem do paciente',
    icon: Weight,
    unit: 'kg',
    step: '0.1',
    min: '0.5',
    max: '400',
    placeholder: '70,0'
  },
  altura: {
    title: 'Registro de altura',
    subtitle: 'Última estatura do paciente',
    icon: Ruler,
    unit: 'm',
    step: '0.01',
    min: '0.3',
    max: '2.5',
    placeholder: '1,70'
  }
}

function AddBodyMeasureModal({ isOpen, kind = 'peso', patientId, patientName, onClose, onAdded }) {
  const config = KINDS[kind] || KINDS.peso
  const Icon = config.icon
  const [value, setValue] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!isOpen) return
    setValue('')
    setError('')
  }, [isOpen, kind])

  const submit = async (event) => {
    event.preventDefault()
    setSaving(true)
    setError('')
    try {
      await patientService.addMeasure(patientId, { kind, value })
      setValue('')
      onAdded()
      onClose()
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível registrar')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={config.title}
      subtitle={config.subtitle}
      icon={<Icon size={22} />}
      size="small"
      footer={(
        <button type="submit" form="body-measure-form" disabled={saving || !String(value).trim()}>
          {saving ? 'Salvando...' : 'Registrar'}
        </button>
      )}
    >
      <form id="body-measure-form" onSubmit={submit}>
        {error && <p className="patients-alert-strip">{error}</p>}
        <p className="patients-note">Paciente: <strong>{patientName}</strong></p>
        <div className="patients-field">
          <label htmlFor="body-measure-value">{kind === 'altura' ? 'Altura' : 'Peso'} ({config.unit})</label>
          <input
            id="body-measure-value"
            type="number"
            inputMode="decimal"
            required
            step={config.step}
            min={config.min}
            max={config.max}
            placeholder={config.placeholder}
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
        </div>
      </form>
    </Modal>
  )
}

export default AddBodyMeasureModal
